import { motion } from "framer-motion";
import { industries } from "@/data";
import { fadeUp, viewport } from "@/lib/motion";

const WhoFor = () => {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden" data-testid="who-for">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-[1fr_1.1fr] gap-12 lg:gap-20 items-center">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}>
          <p className="text-[#ccff00] text-xs font-semibold uppercase tracking-widest mb-4">Built for you</p>
          <h2 className="font-display font-black tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-tight mb-6">
            You start the business. <span className="text-[#ff0055]">We make it look the part.</span>
          </h2>
          <p className="text-lg text-zinc-400 mb-8 max-w-xl">
            You didn't start a cleaning round, a salon or a trade to learn web design. You want customers.
            We handle the brand, the website and the whole online setup so you can get on with the work.
          </p>
          <div className="relative rounded-2xl overflow-hidden border border-white/10">
            <img
              src="https://customer-assets-agu9un31.emergentagent.net/job_brand-to-live/artifacts/0rdwbr9q_51d6f6f9-774e-4c8d-ba4e-ac522a3d99d8.jpg"
              alt="Founder of BrandToBuilt"
              className="w-full h-80 md:h-[30rem] object-cover object-[center_20%]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#060606] via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5">
              <span className="inline-block rounded-full bg-[#ccff00] text-black text-[10px] font-bold uppercase tracking-widest px-3 py-1 mb-2">Meet the founder</span>
              <p className="text-white text-sm md:text-base max-w-md">A real person behind every launch — not a faceless AI factory. I personally quality-check every business before it goes live.</p>
            </div>
          </div>
        </motion.div>

        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="flex flex-wrap gap-3" data-testid="industries">
          {industries.map((ind) => (
            <span
              key={ind}
              className="rounded-full border border-white/10 bg-[#121212] px-5 py-3 text-sm md:text-base text-zinc-300 hover:border-[#ccff00]/60 hover:text-white transition-colors"
              data-testid={`industry-${ind.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {ind}
            </span>
          ))}
          <span className="rounded-full bg-[#ccff00] text-black font-bold px-5 py-3 text-sm md:text-base">…and you.</span>
        </motion.div>
      </div>
    </section>
  );
};

export default WhoFor;
